import React from 'react'
import { connect } from 'react-redux'
import find from 'lodash/find'
import { formatDate } from '../../../utils/formatDate'
import QuestionCountBadge from '../../uiKit/QuestionCountBadge'
import SearchPreviewTileGrid from './SearchPreviewTileGrid'

function SearchPreviewSet({ hit, storeSet }) {
  // Local set carries the full embedded questions[] (with bodyHtml). When the
  // hit is Algolia-only we may still have a partial copy in state.sets; if
  // neither has questions, fall back to a count-only summary.
  const set = storeSet || hit
  const questions = Array.isArray(set && set.questions) ? set.questions : []
  const questionCount = questions.length
  const editedAt = (set && set.clientModified) || (hit && hit.clientModified)

  const tileEntries = questions.map((question, index) => ({
    id: (question && question.id) || `q-${index}`,
    kind: 'question',
    item: question,
  }))

  return (
    <div className='searchPreviewPane searchPreviewPane--set'>
      <div className='searchPreviewPane-header'>
        <div className='searchPreviewPane-header-icon'>
          <QuestionCountBadge color='blueLight' size='medium' questionCount={questionCount} />
        </div>
        <div className='searchPreviewPane-header-text'>
          <div className='searchPreviewPane-header-title'>
            {(set && set.name) || 'Untitled Set'}
          </div>
          {editedAt && (
            <div className='searchPreviewPane-header-subtitle'>
              {'Edited '}
              {formatDate(editedAt)}
            </div>
          )}
        </div>
      </div>
      <div className='searchPreviewPane-body searchPreviewSet'>
        {questionCount > 0 ? (
          <SearchPreviewTileGrid entries={tileEntries} />
        ) : (
          <div className='searchPreviewSet-empty'>
            <QuestionCountBadge color='blueLight' size='medium' questionCount={0} />
            <span>This set has no questions yet.</span>
          </div>
        )}
      </div>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.hit && ownProps.hit.id
  return {
    storeSet: id ? find(state.sets, { id }) : null,
  }
}

export default connect(mapStateToProps)(SearchPreviewSet)
